<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="path"><i class="lt"></i><i class="rt"></i>
      <el-tab-pane name="wbhtgl">
        <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 维保合同管理</span>
        <normalNav :parent="self">
          <button class="GreenSmBtn" @click="u_showModal('adding')">新增</button>
        </normalNav>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_wbhtgl" ref="searchForm_wbhtgl">
            <!-- <template slot="last">
            </template> -->
          </searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable apiUrl="operation/wContract/selectAll" :parent="self" :config="config" :other="other" ref="table_wbhtgl">

            <template slot="last">
              <el-table-column label="维保合同" width="200" align="center">
                <template slot-scope="scope">
                  <a :href="scope.row.contractFile" download="ht.pdf" target="blank" style="color:#FFF" v-if="scope.row.contractFile">合同</a>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="230" align="center">
                <template slot-scope="scope">
                  <el-link icon="iconfont iconcheck" type="text" size="small" @click="u_showModal('readonly',scope.row)">详情</el-link>
                  <el-link icon="iconfont iconedit" type="text" size="small" @click="u_showModal('editing',scope.row)">编辑</el-link>
                  <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteIt(scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>

      </el-tab-pane>
    </el-tabs>

    <modal v-model="b_showModal" @refresh="refresh"></modal>
  </div>
</template>

<script>
// import wbhtgl from "@/store/modules/wbhtgl.js";
import wContract from 'operation/wContract'
import { mapGetters, mapMutations } from 'vuex'
import { yhzt, obj2urlsp, descriptor } from 'utils'
export default {
  created() {
    // this.$store.registerModule("wbhtgl", wbhtgl);
  },
  data() {
    return {
      tabName: 'wbhtgl',
      path: 'wbhtgl',
      form_wbhtgl: {},
      other: {},
      curData: {},
      b_showModal: false,
    }
  },
  computed: {
    ...mapGetters('wbhtgl', ['s_status']),
    self() {
      return this
    },

    items() {
      const that = this
      return [
        {
          type: 'input',
          prop: 'companyName',
          label: '单位名称',
          placeholder: '',
        },
      ]
    },
    config() {
      return [
        {
          prop: 'companyName',
          label: '维保单位',
        },
        {
          prop: 'companyPerson',
          label: '联系人',
        },
        {
          prop: 'companyPhone',
          label: '联系电话',
        },
        {
          prop: 'startDate',
          label: '合同开始时间',
        },
        {
          prop: 'endDate',
          label: '合同结束时间',
        },
        {
          prop: 'empName',
          label: '维保处理人',
        },
      ]
    },
  },
  methods: {
    ...mapMutations('wbhtgl', ['changeStatus', 'changeModel', 'changeWbId']),
    reset_wbhtgl(fn) {
      fn()
      this.form_wbhtgl = {}
    },
    search_wbhtgl(fn) {
      fn()
    },

    u_showModal(status, data) {
      this.changeStatus(status)
      if (data) {
        this.curData = data

        this.changeWbId(this.curData.id)
        wContract.selectOne(this.curData.id).then((res) => {
          let data = res.data.data
          this.changeModel({
            name: 'thebase',
            key: 'companyName',
            value: data.companyName,
          })
          this.changeModel({
            name: 'thebase',
            key: 'companyNumber',
            value: data.companyNumber,
          })
          this.changeModel({
            name: 'thebase',
            key: 'companyPerson',
            value: data.companyPerson,
          })
          this.changeModel({
            name: 'thebase',
            key: 'companyPhone',
            value: data.companyPhone,
          })
          this.changeModel({
            name: 'thebase',
            key: 'startDate',
            value: data.startDate,
          })
          this.changeModel({
            name: 'thebase',
            key: 'endDate',
            value: data.endDate,
          })
          this.changeModel({
            name: 'thebase',
            key: 'contractFile',
            value: data.contractFile,
          })
          this.changeModel({
            name: 'thebase',
            key: 'empId',
            value: data.empId,
          })

          let xc = data.contractTypeList.find(({ typeId }) => typeId == 1)
          if (xc) {
            this.changeModel({
              name: 'xc',
              key: 'typeInfoId',
              value: xc.typeInfoIds,
            })
            this.changeModel({
              name: 'xc',
              key: 'period',
              value: xc.period,
            })
            this.changeModel({
              name: 'xc',
              key: 'checked',
              value: true,
            })
          }

          let jc = data.contractTypeList.find(({ typeId }) => typeId == 2)
          if (jc) {
            this.changeModel({
              name: 'jc',
              key: 'typeInfoId',
              value: jc.typeInfoIds,
            })
            this.changeModel({
              name: 'jc',
              key: 'period',
              value: jc.period,
            })
            this.changeModel({
              name: 'jc',
              key: 'checked',
              value: true,
            })
          }

          let by = data.contractTypeList.find(({ typeId }) => typeId == 3)
          if (by) {
            this.changeModel({
              name: 'by',
              key: 'period',
              value: by.period,
            })
            this.changeModel({
              name: 'by',
              key: 'checked',
              value: true,
            })
          }
          this.$nextTick(() => (this.b_showModal = true))
        })
      } else {
        this.b_showModal = true
      }
    },
    deleteIt({ id }) {
      this.$confirm('确定删除?', '', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        confirmButtonClass: 'confirmButton',
        cancelButtonClass: 'cancelButton',
        type: 'warning',
      })
        .then(() => {
          wContract.deleteContract(id).then((res) => {
            this.$message.success('删除成功')
            this.refresh()
          })
        })
        .catch(() => {})
    },
    refresh() {
      this.$refs['table_wbhtgl'].getData()
    },
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    modal: () => import('./modal'),
  },
  mounted() {
    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });
    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  },
}
</script>

<style lang="less" scoped>
.content {
  /deep/.systemAlarm {
    .el-tabs__content {
      font-size: 15px !important;
    }

    .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px;
    }

    .el-tabs__item.is-top:last-child {
      padding-right: 20px;
    }

    .el-tabs__item {
      color: #ccc;
      padding: 0 20px;
      height: 40px;
      box-sizing: border-box;
      line-height: 40px;
      display: inline-block;
      list-style: none;
      font-size: 14px;
      font-weight: 500;
    }

    .el-tabs__item.is-active {
      background-color: #253253;
      border-left: 1px solid #30426f;
    }

    #tab-first {
      padding-left: 20px;
    }

    #tab-second {
      padding-right: 20px;
    }

    .el-tabs__active-bar {
      background-image: linear-gradient(-90deg, #8652e7 0%, #35bfff 100%), linear-gradient(#35b9f7, #35b9f7);
    }

    .el-tabs__nav-wrap::after {
      background-color: #2d374d;
      /* height: 1px; */
    }

    /deep/ .el-tabs .loading {
      height: 300px;
      // background-image: url("./video.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 30px;
        height: 30px;
        animation: xuanzhuan 1.5s linear infinite;
      }

      @keyframes xuanzhuan {
        0% {
          -webkit-transform: rotate(0deg);
        }

        100% {
          -webkit-transform: rotate(360deg);
        }
      }
    }
  }
}

.editDialog .el-dialog__body {
  padding-top: 0;
}

.editDialog .list {
  width: 100%;
  margin-top: 17px;
  margin-bottom: 17px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}

.editDialog .list > ul {
  flex: 1;
  padding-right: 20px;
}

.editDialog .list > ul + ul {
  flex: 1;
  padding-left: 20px;
}

.editDialog .list::before {
  content: '';
  width: 1px;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 50%;
}

.editDialog .list li {
  font-size: 14px;
  line-height: 32px;
  color: #cccccc;
}

.box-card {
  background: transparent;
  border: 1px solid #2d374d;
  color: #ccc;
}

.point {
  span {
    padding-left: 5px;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom: 1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/upkeep/wbhtgl/index.vue